'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var types = {
  STRING: 'string',
  SELECT: 'select',
  TEXT_AREA: 'text_area'
};

var showInSharedList = exports.showInSharedList = false;

exports.default = types;

//# sourceMappingURL=argTypes.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@bit/fabfitfun.shared.utils.arg-types/dist/argTypes.js
// module id = 19
// module chunks = 0